import React, { FC, memo } from 'react'
import { Formik } from 'formik'
import SC from '../base/Facet.styles'
import { IFacetProps } from '../types'
import { Heading } from '../../Heading/desktop'
import { Spacing } from '../../Spacing/desktop'
import { useFacetCore } from '../bll'
import FacetForm from './FacetForm'

const { Block } = SC

/** Фасет с набором чекбоксов или радиокнопок */
const Facet: FC<IFacetProps> = (props) => {
  const {
    title,
    controlName,
    items,
    isRadio,
    spacing = 'xxlarge',
    onSubmit,
    isForcedArray,
    maxItems,
    expandButtonText = 'Показать все',
    afterTitleElement,
    fontWeight,
    initialValues,
    fillByQuery = true,
    ...otherProps
  } = props

  const { initialValue, onSubmitForm } = useFacetCore({
    controlName,
    isRadio,
    isForcedArray,
    onSubmit,
    initialValues,
  })

  if (!items.length) return null

  return (
    <Block {...otherProps}>
      {title && <Heading h4={title} spacing='large' />}

      {afterTitleElement}

      <Formik initialValues={initialValue} enableReinitialize onSubmit={onSubmitForm}>
        <FacetForm
          items={items}
          maxItems={maxItems}
          expandButtonText={expandButtonText}
          controlName={controlName}
          isForcedArray={isForcedArray}
          isRadio={isRadio}
          fontWeight={fontWeight}
          fillByQuery={fillByQuery}
        />
      </Formik>

      <Spacing spacing={spacing} />
    </Block>
  )
}

export { Facet }
export default memo(Facet)
